import { Component, signal } from '@angular/core';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
  selector: 'app-loading-overlay-component',
  imports: [],
  templateUrl: './loading-overlay-component.html',
  styleUrl: './loading-overlay-component.css',
})
export class LoadingOverlayComponent {
  loadingMessage = signal('');
  displaySpinner = signal(true);

  agInit(params: ILoadingOverlayParams & { loadingMessage: string, displaySpinner: boolean }): void {
    this.loadingMessage.set(params.loadingMessage);

    if (params.displaySpinner === false) {
      this.displaySpinner.set(params.displaySpinner);
    }
  }
}
